import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import BoxDesign from './BoxDesign';
import { IconBuilding } from '../../Assets/contacts/IconBuilding';
import { IconDate } from '../../Assets/IconDate';
import { DictioneryPanel } from '../../Data/DictioneryPanel';
import { langDateChange } from '../Inputs/DateInputWTitle';
import { IconRouting } from '../../Assets/panels/IconRouting';
import { LoadingColor } from '../LoadingColor';
import { IconTimer } from '../../Assets/panels/IconTimer';
import { IconHotels } from '../../Assets/panels/IconHotels';
import { IconResurant } from '../../Assets/panels/IconResurant';
import { formatPrice } from '../Functions/Price';
const Styles = styled.div`
    width: 100%;
    .over-route {
        margin: 0 1rem 1rem;
        padding: 1.25rem;
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        .title-part {
            color: var(--text-h);
            display: flex;
            align-items: center;
            gap: 1rem;
            &.active {
                color: var(--main-color);
                .icon {
                    fill: var(--main-color);
                }
            }
            &.inside {
                color: #000000;
                .icon {
                    fill: var(--n-grey-2);
                }
            }
            .icon {
                fill: var(--text-h);
                width: 48px;
                height: 48px;
                display: block;
            }
            .text {
                font-weight: 700;
                font-size: 1.25rem;
            }
        }
        .line {
            height: 1px;
            background-color: var(--n-grey-1);
        }
        .box-routing {
            border-radius: var(--border-radius-3);
            background-color: var(--n-grey-01);
            padding: 1.5rem 2rem;
            display: flex;
            gap: 3rem;
            align-items: center;
            justify-content: space-between;
            .line-h {
                align-self: normal;
                width: 2px;
                background-color: var(--n-grey-11);
                color: #FFFFFF00;
            }
            .data {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                .title {
                    font-size: 0.75rem;
                    font-weight: 500;
                    color: var(--n-grey-2);
                }
                .value {
                    font-size: 1.25rem;
                    font-weight: 500;
                }
            }
        }
    }
    @media screen and (max-width: 850px) {
        .over-route {
            .box-routing {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 0.5rem;
                align-items: center;
                justify-items: center;
                .data {
                    justify-self: start;
                }
            }
        }
    }
`
export default function TourDetailsDatesCart ({loading = true, data, lang}){
    
    const makeDates = () => {
        let details = data.DATES ? data.DATES : [];
        let isMobile = (window.innerWidth < 850) ? true : false;
        return details.map((v, i) => {
            let date1 = langDateChange(v.Tour_Dt_Departure_Date, lang);
            let date2 = langDateChange(v.Tour_Dt_Return_Date, lang);
            return (
                <div className='box-routing' key={i + "b"}>
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.goDate[lang]}
                        </div>
                        <div className='value'>
                            {date1}
                        </div>
                    </div>
                    <div className='line-h'>-</div>
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.backDate[lang]}
                        </div>
                        <div className='value'>
                            {date2}
                        </div>
                    </div>
                    {
                        (!isMobile) ? (
                            <div className='line-h'>-</div>
                        ) : ""
                    }
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.tourCapacity[lang]}
                        </div>
                        <div className='value'>
                            {v.Tour_Dt_Capacity}
                        </div>
                    </div>
                    <div className='line-h'>-</div>
                    <div className='data'>
                        <div className='title'>
                            {DictioneryPanel.packagesDict.tourDatePrice[lang]}
                        </div>
                        <div className='value'>
                            {formatPrice(v.Tour_Price)} {v.Currency_Name}
                        </div>
                    </div>
                </div>
            )
        });
    }
    if(loading){
        return (
            <Styles>
                <LoadingColor/>
            </Styles>
        )
    }
    return (
        <Styles>
            <BoxDesign className='over-route'>
                {makeDates()}
            </BoxDesign>
        </Styles>
    )
}